import {
  ACTIONS,
  IAcquisitionStore,
  TAcquisitionState,
} from '../../providers/ModernAcquisitionProvider/types';

export type TModernWriteManager = {
  acquisitionStore: IAcquisitionStore;
  modernFields: Array<keyof TAcquisitionState>,
}

const modernWriteManager = (
  acquisitionStore: IAcquisitionStore,
  modernFields: Array<keyof TAcquisitionState>,
) => {
  const write = (updates: TAcquisitionState) => {
    const filterForFields = (fields: Array<keyof TAcquisitionState>) => {
      return Object.fromEntries(
        Object.entries(updates).filter(([key]) =>
          fields.includes(key as keyof TAcquisitionState),
        ),
      );
    }

    const filtered = filterForFields(modernFields);
    acquisitionStore.dispatch({
      type: ACTIONS.BULK_UPDATE_FIELD,
      payload: { ...filtered },
    });
  };

  return {
    write,
  };
};

export default modernWriteManager;
